import React from 'react'
import PropTypes from 'prop-types'
import { MessageErrorInput } from 'Components/Message/Error/input'
import Slider from 'rc-slider'
import brandTheme from '../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const SliderUnstyled = props => {
  const { id, disabled = false, name, unit, min, max } = props
  var onChange = (props.input || {}).onChange || props.onChange
  var onBlur = (props.input || {}).onBlur || props.onBlur
  var defaultValue = (props.input || {}).defaultValue || props.defaultValue
  var value = (props.input || {}).value || props.value
  const className = `${props.className} ${props.className || ''} ${
    hasError() ? 'has-error' : ''
  }`

  return [
    <div key="input" className={className}>
      {renderLabel()}
      <Slider
        id={id}
        test-id={props['test-id']}
        name={name}
        disabled={disabled}
        defaultValue={defaultValue ? defaultValue : ''}
        onChange={onChange}
        type="range"
        onBlur={onBlur}
        value={value ? value : ''}
        min={min}
        max={max}
        trackStyle={{ backgroundColor: colors.primary }}
        handleStyle={{ borderColor: colors.primary }}
      />
      <div className="range-values">
        <div>{`${min} ${unit}`}</div>
        <div>{`${max} ${unit}`}</div>
      </div>
    </div>,
    renderError(),
  ]

  /**
   * Render label
   * @returns JSX.Element | null
   */
  function renderLabel() {
    const { label, id, unit } = props
    return label ? (
      <label className="label" htmlFor={id}>
        <span>{label}</span>
        <span className="value">{`${value} ${unit}`}</span>
      </label>
    ) : null
  }

  /**
   * Input has error
   * @returns boolean
   */
  function hasError() {
    return (
      props.error || ((props.meta || {}).touched && (props.meta || {}).error)
    )
  }

  /**
   * Render field error
   * @returns JSX.Element | null
   */
  function renderError() {
    const inputError = (props.meta || {}).error || props.errors

    return hasError() ? (
      <MessageErrorInput key="errorMessage" message={inputError} />
    ) : null
  }
}

SliderUnstyled.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.oneOf(['user', 'password', 'email']),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  input: PropTypes.shape({
    onChange: PropTypes.func,
  }),
}



// WEBPACK FOOTER //
// ./src/Components/Form/Slider/unstyled.js